import * as React from 'react';
export const IcSelect = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.52 9.04l-15-6.82C4.14 1.59 2.4 2.31 2 4.07c-.1.46-.03.94.17 1.36L9.1 20.67c.19.42.5.79.91 1 1.71.88 3.44-.13 3.75-1.68l.51-2.57a4.01 4.01 0 013.14-3.14l2.72-.54c.45-.09.89-.31 1.18-.66 1.24-1.46.66-3.38-.79-4.04z'
      fill='currentColor'
    />
  </svg>
);
